import { render, staticRenderFns } from "./IconInfoLight.vue?vue&type=template&id=2e2483ac&"
import script from "./IconInfoLight.vue?vue&type=script&lang=js&"
export * from "./IconInfoLight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports